import React, { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import { fetchProducts } from "../../lib/api";
import { ProductCard } from "../ProductCard";

export const BestSellersCarousel = () => {
  const [products, setProducts] = useState([]);
  const scroller = useRef(null);

  useEffect(() => {
    fetchProducts({ badge: "bestseller", limit: 12 }).then((data) => {
      if (data.length) setProducts(data);
      else fetchProducts({ limit: 12 }).then(setProducts).catch(() => {});
    }).catch(() => {});
  }, []);

  const scrollBy = (dir) => {
    scroller.current?.scrollBy({ left: dir * 320, behavior: "smooth" });
  };

  if (!products.length) return null;

  return (
    <section className="py-12 sm:py-16 bg-maroon relative overflow-hidden" data-testid="bestsellers-carousel-section">
      {/* ghost watermark */}
      <span aria-hidden="true" className="pointer-events-none select-none absolute -top-6 left-0 font-heading italic text-[22vw] leading-none text-ivory/[0.04] whitespace-nowrap">
        Bestsellers
      </span>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative">
        <div className="flex items-end justify-between gap-6">
          <div>
            <p className="uppercase tracking-[0.25em] text-xs font-semibold text-gold">Loved by our customers</p>
            <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl tracking-tight font-medium text-ivory mt-3">
              Best Sellers, <span className="italic font-light text-gold">Straight off the Loom</span>
            </h2>
          </div>
          <div className="hidden sm:flex items-center gap-2">
            <button onClick={() => scrollBy(-1)} data-testid="bestsellers-carousel-prev" aria-label="Previous" className="w-11 h-11 border border-ivory/30 flex items-center justify-center text-ivory hover:bg-ivory hover:text-maroon transition-colors">
              <ChevronLeft className="w-5 h-5" strokeWidth={1.5} />
            </button>
            <button onClick={() => scrollBy(1)} data-testid="bestsellers-carousel-next" aria-label="Next" className="w-11 h-11 border border-ivory/30 flex items-center justify-center text-ivory hover:bg-ivory hover:text-maroon transition-colors">
              <ChevronRight className="w-5 h-5" strokeWidth={1.5} />
            </button>
          </div>
        </div>

        <div ref={scroller} className="mt-7 flex gap-4 sm:gap-6 overflow-x-auto no-scrollbar snap-x snap-mandatory -mx-4 px-4 lg:mx-0 lg:px-0 pb-2">
          {products.map((p) => (
            <div key={p.id} className="min-w-[70vw] sm:min-w-[300px] lg:min-w-[calc(25%-1.5rem)] snap-start">
              <ProductCard product={p} />
            </div>
          ))}
        </div>

        <div className="mt-6 text-center">
          <Link to="/shop?badge=bestseller" data-testid="bestsellers-carousel-viewall" className="inline-block border border-gold/60 text-gold px-9 py-3.5 text-xs tracking-[0.22em] uppercase hover:bg-gold hover:text-charcoal transition-colors">
            View All Best Sellers
          </Link>
        </div>
      </div>
    </section>
  );
};
